<template>
    <div class="page-content" v-if="itemsReady">
        <ReportingSuggestDesktopUse v-if="isMobileView" />
        <template v-else>
            <UserHeadline title="OrganizationReport.org_report" />
            <ReportingNotificationForNight />
            <Tabs v-if="isLoggedIn" tabsMainClass="tabs-with-underline" :wrap="false" v-slot="tabsProps">
                <Tab @tabMounted="tabsProps.onTabMounted"
                     :activeTab="tabsProps.activeTab"
                     id="users-tab-id"
                     :title="$t('OrganizationReport.tabs_users_title')">
                    <Users />
                </Tab>
                <Tab @tabMounted="tabsProps.onTabMounted"
                     :activeTab="tabsProps.activeTab"
                     :title="$t('OrganizationReport.tabs_courses_title')">
                    <Courses />
                </Tab>
            </Tabs>
        </template>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import UserHeadline from 'components/user/UserHeadline'
    import loadingOverlay from 'components/shared/mixins/loadingOverlay'
    import summitEventHelper from 'helpers/summitEventHelper'
    import Tab from 'components/layout/Tab'
    import Tabs from 'components/layout/Tabs'
    import Users from 'components/user/organizationreport/tabs/users/Users'
    import Courses from 'components/user/organizationreport/tabs/courses/Courses'
    import ReportingSuggestDesktopUse from 'components/user/organizationreport/ReportingSuggestDesktopUse'
    import ReportingNotificationForNight from 'components/user/organizationreport/ReportingNotificationForNight'

    export default {
        components: {
            UserHeadline,
            Tab,
            Tabs,
            Users,
            Courses,
            ReportingSuggestDesktopUse,
            ReportingNotificationForNight
        },
        mixins: [loadingOverlay, summitEventHelper],
        data () {
            return {
                itemsReady: false
            }
        },
        computed: {
            ...mapGetters({
                reportingItems: 'User/getReportingItems',
                isLoggedIn: 'isLoggedIn',
                reportingExcelLink: 'User/getReportingExcelLink'
            })
        },
        methods: {
            showReportingDisabledModal () {
                if (this.isInSummitTimeRange) {
                    this.$modal.show('organization-reporting-disabled')
                } else {
                    this.$modal.hide('organization-reporting-disabled')
                }
            }
        },
        async created () {
            const taskName = 'loadingOrganizationReport'
            if (!this.isInSummitTimeRange) {
                try {
                    if (this.isLoggedIn) {
                        await this.$store.dispatch('LoaderScreen/addTaskToLoader', {
                            key: taskName,
                            message: 'Loading Organization Report'
                        })

                        this.itemsReady = true
                    }
                } catch (e) {
                    if (e.code === 404 || e.response.status === 404) {
                        this.$router.push({ name: 'page-not-found' })
                    }
                    if (e.code === 403 || e.response.status === 403) {
                        this.$router.push({ name: 'page-no-permission' })
                    }
                    throw e
                }
                this.$store.dispatch('LoaderScreen/removeTaskFromLoader', taskName)
            }
        },
        watch: {
            isInSummitTimeRange: {
                handler: 'showReportingDisabledModal',
                immediate: true
            }
        }
    }
</script>

<style lang="scss">
    @include tabs_with_underline;
</style>
